import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BatteryChargingFull, EvStation, Analytics, History } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Title from '../../components/Title';
import BatteriesTab from './components/BatteriesTab';
import ChargingStationsTab from './components/ChargingStationsTab';
import EfficiencyTab from './components/EfficiencyTab';
import HistoryTab from './components/HistoryTab';

const Root = styled('div')({
  padding: 0,
  minHeight: 'calc(100vh - 180px)'
});

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: 24,
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTab-root': {
    minHeight: 48,
    textTransform: 'none',
    fontSize: '0.95rem',
    fontWeight: 500
  }
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const BatteriesPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Root>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Title>{t('batteries.title')}</Title>
      </Box>

      <StyledTabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
        <Tab icon={<BatteryChargingFull />} iconPosition="start" label={t('batteries.tabBatteries')} />
        <Tab icon={<EvStation />} iconPosition="start" label={t('batteries.tabChargingStations')} />
        <Tab icon={<Analytics />} iconPosition="start" label={t('batteries.tabEfficiency')} />
        <Tab icon={<History />} iconPosition="start" label={t('batteries.tabHistory')} />
      </StyledTabs>

      <TabPanel value={activeTab} index={0}>
        <BatteriesTab />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <ChargingStationsTab />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <EfficiencyTab />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <HistoryTab />
      </TabPanel>
    </Root>
  );
};

export default BatteriesPage;
